var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDotsSixVertical(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4356_90412)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.874 8.3125C11.8405 8.3125 12.624 7.529 12.624 6.5625C12.624 5.596 11.8405 4.8125 10.874 4.8125C9.90753 4.8125 9.12402 5.596 9.12402 6.5625C9.12402 7.529 9.90753 8.3125 10.874 8.3125Z",
    fill: "#A4A4B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.749 8.3125C19.7155 8.3125 20.499 7.529 20.499 6.5625C20.499 5.596 19.7155 4.8125 18.749 4.8125C17.7825 4.8125 16.999 5.596 16.999 6.5625C16.999 7.529 17.7825 8.3125 18.749 8.3125Z",
    fill: "#A4A4B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.874 15.75C11.8405 15.75 12.624 14.9665 12.624 14C12.624 13.0335 11.8405 12.25 10.874 12.25C9.90753 12.25 9.12402 13.0335 9.12402 14C9.12402 14.9665 9.90753 15.75 10.874 15.75Z",
    fill: "#A4A4B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.749 15.75C19.7155 15.75 20.499 14.9665 20.499 14C20.499 13.0335 19.7155 12.25 18.749 12.25C17.7825 12.25 16.999 13.0335 16.999 14C16.999 14.9665 17.7825 15.75 18.749 15.75Z",
    fill: "#A4A4B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.874 23.1875C11.8405 23.1875 12.624 22.404 12.624 21.4375C12.624 20.471 11.8405 19.6875 10.874 19.6875C9.90753 19.6875 9.12402 20.471 9.12402 21.4375C9.12402 22.404 9.90753 23.1875 10.874 23.1875Z",
    fill: "#A4A4B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.749 23.1875C19.7155 23.1875 20.499 22.404 20.499 21.4375C20.499 20.471 19.7155 19.6875 18.749 19.6875C17.7825 19.6875 16.999 20.471 16.999 21.4375C16.999 22.404 17.7825 23.1875 18.749 23.1875Z",
    fill: "#A4A4B2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4356_90412"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(0.811523)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsSixVertical);
export default __webpack_public_path__ + "static/media/DotsSixVertical.e315c639e5582203f5558cea064982f8.svg";
export { ForwardRef as ReactComponent };